import { BaseEntity } from './base-entity';
import { EntityType } from './entity-type';
import { RiskTemplateTypes } from './risk-template-types';

export class RiskTemplate extends BaseEntity {
  description: string;
  threats: Array<BaseEntity> = [];
  targetEntityType?: EntityType;
  templateType: RiskTemplateTypes;
}
